<ng-container *ngIf="localization">
	<h3 mat-dialog-title>
		<span>{{'Localizing' | cmLocalize:locFeature + '/System.LocalizeModal.Title.Localizing'}}</span>
		<span *ngIf="localization?.name"> &mdash; {{ localization?.name }}</span>
	</h3>
	<div mat-dialog-content class="localization-modal"
		[ngClass]="{'localization-modal--html': localization?.htmlAllowed}">


		<div class="localization-modal__header">
			<span class="localization-modal__title mr-16">
				{{ localization?.uiType || '' | atsSplitPascal }}
			</span>
			<div class="localization-modal__actions">
				<button mat-button cm-mini-button color="warn" (click)='deleteLoc()'
					[matTooltip]="'Delete' | cmLocalize:locFeature + '/System.LocalizeModal.Button.Delete'"
					[attr.aria-label]="'Delete' | cmLocalize:locFeature + '/System.LocalizeModal.Button.Delete'">
					<ats-icon [size]="14" name="trash"></ats-icon>
				</button>
			</div>
		</div>

		<ng-container *ngIf="!localization?.htmlAllowed; else HTMLForm">
			<div class="localization-modal__content">
				<form #f class="localization-modal__text-form" *ngIf="!localization?.htmlAllowed; else HTMLForm">
					<cm-key-val-list>
						<ng-container [ngTemplateOutlet]="description"></ng-container>
						<div cm-key-val>
							<label kv-key>{{'Shared' | cmLocalize:locFeature +
								'/System.LocalizeModal.FieldLabel.Shared'}}</label>
							<span>{{ localization?.shared | cmBool }}</span>
						</div>
						<div cm-key-val>
							<label kv-key>{{'Allows HTML' |
								cmLocalize:locFeature + '/System.LocalizeModal.FieldLabel.AllowsHtml'}}</label>
							<span>{{ localization?.htmlAllowed | cmBool }}</span>
						</div>
						<div cm-key-val>
							<label kv-key>{{'Default Value' |
								cmLocalize:locFeature + '/System.LocalizeModal.FieldLabel.DefaultValue'}}</label>
							<span>{{ localization?.defaultValue }}</span>
						</div>
						<div cm-key-val>
							<label kv-key>{{'Current Value' |
								cmLocalize:locFeature +
								'/System.LocalizeModal.FieldLabel.CurrentValue'}}</label>
							<div class="localization-modal__current-value">{{ displayVal }}</div>
						</div>
					</cm-key-val-list>
					<ng-container [ngTemplateOutlet]="language"></ng-container>
					<mat-form-field>
						<mat-label>{{'New Value' | cmLocalize:locFeature +
							'/System.LocalizeModal.FieldLabel.NewValue'}}
						</mat-label>
						<input matInput type="text" [(ngModel)]="newVal" name="newValue" cdkFocusInitial
							(keydown.enter)='saveLocalization()'>
					</mat-form-field>
				</form>
			</div>
		</ng-container>
	</div>

	<div mat-dialog-actions>
		<button (click)='closeDialog()'>{{'Cancel Changes' |
			cmLocalize:locFeature + '/System.LocalizeModal.Button.CancelChanges'}}</button>
		<button class="primary" (click)='saveLocalization()'>{{'Save Changes' |
			cmLocalize:locFeature + '/System.LocalizeModal.Button.SaveChanges'}}</button>
	</div>

	<ng-template #HTMLForm>
		<form #f class="localization-modal__html-form">
			<cm-key-val-list>
				<ng-container [ngTemplateOutlet]="description"></ng-container>
			</cm-key-val-list>
			<mat-tab-group (selectedTabChange)="handleTabChange($event)">
				<mat-tab>
					<ng-template mat-tab-label>
						<span>{{'Edit' | cmLocalize:locFeature + '/System.LocalizeModal.Title.Edit'}}</span>
					</ng-template>
					<ng-template matTabContent>
						<ng-container [ngTemplateOutlet]="language"></ng-container>
						<div class="localization-modal__tab-content">
							<editor [(ngModel)]="newVal" [init]="tiny.CONFIG" [apiKey]="tiny.API_KEY" name="newValue"
								#editor class="localization-modal__editor"></editor>
						</div>
					</ng-template>
				</mat-tab>
				<mat-tab>
					<ng-template mat-tab-label>
						<span>{{'Default Value' | cmLocalize:locFeature +
							'/System.LocalizeModal.FieldLabel.DefaultValue'}}</span>
					</ng-template>
					<div class="localization-modal__tab-content">
						<div [innerHTML]="localization?.defaultValue"></div>
					</div>
				</mat-tab>
				<mat-tab>
					<ng-template mat-tab-label>
						<span>{{'Current Value' | cmLocalize:locFeature +
							'/System.LocalizeModal.FieldLabel.CurrentValue'}}</span>
					</ng-template>
					<div class="localization-modal__tab-content">
						<div [innerHTML]="displayVal"></div>
					</div>
				</mat-tab>
			</mat-tab-group>
		</form>
	</ng-template>

	<ng-template #description>
		<div cm-key-val [ngClass]="{'span-all': ((cultures$ | async)?.length <= 1)}">
			<label kv-key>{{'Description' |
				cmLocalize:locFeature + '/System.LocalizeModal.FieldLabel.Description'}}</label>
			<span>{{ localization?.description }}</span>
		</div>
	</ng-template>

	<ng-template #language>
		<ng-container *ngIf="(supportedCultures$ | async)?.length > 1">
			<form [formGroup]="languageForm">
				<mat-form-field>
					<mat-label>
						{{"Language" | cmLocalize:locFeature +
						"/System.LocalizeModal.FieldLabel.Language"}}
					</mat-label>
					<mat-select formControlName="language">
						<mat-option *ngFor="let lang of supportedCultures$ | async" [value]="lang.code">
							{{lang.label}} ({{lang.nativeLabel}})
						</mat-option>
					</mat-select>
				</mat-form-field>
			</form>
		</ng-container>
	</ng-template>
</ng-container>
